import type { WidgetConfig } from '../types/widget';

export const defaultWidgetConfig: WidgetConfig = {
  preset: 'studio',
  // Widget Identity
  widgetTitle: "AI Assistant",
  collapsedMessage: "Need Help? Ask {botName}!",
  inputPlaceholder: "Type your message...",
  botAvatarImageUrl: "",
  welcomeStrategy: 'default',
  defaultWelcome: "Hello there! I'm {botName}. How can I assist you today?",
  ruleBasedWelcome: [
    { if_url_contains: '/pricing', if_hostname_is: '', message: "Looking at our pricing? I can help explain our plans!" },
    { if_url_contains: '/support', if_hostname_is: '', message: "Welcome to support! What can I help you find?" },
  ],
  llmWelcomePrompt: 'You are {botName}, a friendly AI assistant. ...',
  llmWelcomeModel: '',

  // Appearance (legacy nested)
  appearance: {
    fontFamily: "...",
    fontSizeBase: "15px",
    widgetShadow: "...",
    bubbleShadow: "...",
    widgetMaxWidth: "380px",
    widgetMaxHeight: "640px",
    showCollapsedThinking: true,
    maxMessageLength: 2500,
    defaultMinimized: false,
    autoOpenDelay: 700,
  },

  // Colors (extended palette)
  colors: {
    primary: "#007AFF",
    primaryGradient: "linear-gradient(145deg, #0A84FF, #007AFF)",
    widgetBackground: "#FFFFFF",
    messagesBackground: "#F9F9FB",
    textColorPrimary: "#1A1A1A",
    textColorSecondary: "#555555",
    textColorOnPrimary: "#FFFFFF",
    userBubbleBackground: "#007AFF",
    textColorUserBubble: "#FFFFFF",
    botBubbleBackground: "#ECECEC",
    textColorBotBubble: "#1A1A1A",
    botBubbleBorder: "transparent",
    systemBubbleBackground: "#F0F2F5",
    systemBubbleColor: "#3C3C3F",
    systemBubbleBorder: "transparent",
    borderColor: "#DCDCDC",
    focusRingColor: "rgba(0, 122, 255, 0.3)",
  },

  // Border radius
  borderRadius: {
    small: "6px",
    medium: "12px",
    large: "18px",
    full: "9999px",
  },

  // Behavior
  showThinkingProcess: true,
  streamingEnabled: true,
  features: {
    threadsEnabled: false,
    commentsEnabled: false,
    attachmentsEnabled: true,
    historyEnabled: true,
    tabsEnabled: true,
  },
  markdownSupport: {
    enableUserMarkdown: false,
    enableAssistantMarkdown: true,
  },
  errorMessages: {
    default: "I seem to be having a little trouble...",
    unauthorized: "Please refresh.",
  },
  contextPrepending: {
    url: true,
    hostname: false,
    store: true,
  },

  themeColor: "#007AFF",
  position: 'bottom-right',

  // Device-aware open behavior
  defaultMinimizedDesktop: false,
  defaultMinimizedMobile: false,
  autoOpen: { delayDesktop: 0, delayMobile: 0, oncePerSession: false },

  // Mobile modes
  mobileMode: 'half',
  mobileHalfHeight: '50dvh',
};

export const colorPalette = [
  '#007AFF', '#34C759', '#FF9500', '#FF3B30', '#AF52DE', '#5856D6',
  '#5AC8FA', '#32D74B', '#FF9F0A', '#FF453A', '#BF5AF2', '#6366F1'
];

export const fontFamilyOptions = [
  { value: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'", label: "System Default" },
  { value: "'Inter', sans-serif", label: "Inter" },
  { value: "'Poppins', sans-serif", label: "Poppins" },
];

export const positionOptions = [
  { value: 'bottom-right', label: 'Bottom Right' },
  { value: 'bottom-left', label: 'Bottom Left' },
  { value: 'top-right', label: 'Top Right' },
  { value: 'top-left', label: 'Top Left' },
];

export const welcomeStrategyOptions = [
  { value: 'default', label: 'Default Message' },
  { value: 'rules', label: 'Rule-Based Messages' },
  { value: 'llm', label: 'LLM Generated' },
];

export const mobileModeOptions = [
  { value: 'half', label: 'Half-screen (bottom sheet)' },
  { value: 'full', label: 'Full-screen' },
  { value: 'floating', label: 'Floating (latest message only)' },
];
